export const dimensions: (string | string[])[] = [
  'Sales Segmentation',
  'Influencers',
  ['Channel', 'Preference'],
  ['Communication', 'Style'],
  'Persona',
  'Adoption',
  ['Implementation/', 'Insights'],
];

export const industryAverageData = [68, 56, 46, 51, 43, 57, 45];

// You could also define best practice data here if needed
// export const bestPracticeData = [100, 100, 100, 100, 100, 100, 100];
